// @flow

import React from 'react';
import { get } from 'lodash';

import { isBrowser } from '@zapier/common-utils';

import ApolloQuery from 'web-ssr/app/common/components/ApolloQuery';
import isAuthenticated from 'web-ssr/graphql/queries/currentUser/isAuthenticated';

import type { Node } from 'react';

import type { QueryControls } from 'web-ssr/app/common/components/ApolloQuery';
import type { isAuthenticatedQuery } from 'web-ssr/graphql/types';

type QueryData = {
  ...$Exact<QueryControls>,
  data: isAuthenticatedQuery,
};

type Props = {
  children: ({ isAuthenticated: boolean }) => Node,
};

const WithAuthentication = (props: Props) => {
  const { children } = props;

  return (
    <ApolloQuery query={isAuthenticated} skip={!isBrowser()}>
      {(result: QueryData) => {
        return children({
          isAuthenticated: get(result, ['data', 'isAuthenticated']) || false,
        });
      }}
    </ApolloQuery>
  );
};

export default WithAuthentication;
